// src/pages/Groups.js
import React, { useState, useEffect } from 'react';
import GroupList from './parts/GroupList';
import GroupDetail from './parts/GroupDetail';
import OrganisationFilter from './widgets/OrganisationFilter';
import { apiService } from './services/api';
import './style/PageStyle/Groups.css';

const Groups = () => {
  // --- State ---
  const [allGroups, setAllGroups] = useState([]); 
  const [organisations, setOrganisations] = useState([]); 
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedOrgName, setSelectedOrgName] = useState('All');
  const [isLoading, setIsLoading] = useState(true);

  // --- Initial Data Loading ---
  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        const [groupsData, orgsData] = await Promise.all([
          apiService.getGroups(),
          apiService.getOrganisations()
        ]);
        
        const safeGroups = Array.isArray(groupsData) ? groupsData : [];
        const safeOrgs = Array.isArray(orgsData) ? orgsData : [];
        
        setAllGroups(safeGroups);
        setOrganisations(safeOrgs);

        if (safeGroups.length > 0) {
          setSelectedGroup(safeGroups[0]);
        }
      } catch (error) {
        console.error("Failed to load data", error);
        setAllGroups([]);
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, []);

  return (
    <div className="groups-container">
      
      {/* --- Page Header --- */}
      <div className="groups-header">
        <h1 className="groups-title">Group Management</h1>
        <p className="groups-subtitle">
          Manage user roles, permissions, and access levels across organisations.
        </p>
      </div>

      {/* --- FILTER WIDGET --- */}
      <OrganisationFilter 
        organisations={organisations}
        selectedOrg={selectedOrgName}
        onSelectOrg={setSelectedOrgName}
      />

      {/* --- Main Content --- */}
      {isLoading ? (
        <div className="groups-loading">Loading groups...</div>
      ) : (
        <div className="groups-layout">
          <GroupList 
            groups={allGroups} 
            selectedGroupId={selectedGroup?.id} 
            onSelect={setSelectedGroup} 
          />

          <GroupDetail 
            group={selectedGroup} 
            filterOrg={selectedOrgName} 
          />
        </div>
      )}
    </div>
  );
};

export default Groups;
